module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "adaptation flex justify-between align-start"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "bg-white",
    staticStyle: {
      "width": "100%",
      "padding": "20px 30px",
      "border-radius": "10px"
    }
  }, [_c('div', {}, [(_vm.typelist.length) ? _c('div', {}, [_c('div', {
    staticClass: "box2_until"
  }, _vm._l((_vm.typelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "borbot",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "box2_until_center"
    }, [_c('div', {
      staticClass: "box2_until_left"
    }, [_vm._v(_vm._s(item.name) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "box2_cent"
    }, _vm._l((item.union_type), function(citem, cindex) {
      return _c('div', {
        key: cindex,
        staticClass: "box2_until_right cpoint",
        class: citem.checked ? 'sty' : '',
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.tochoose(
              index,
              cindex,
              citem.id,
              citem.name,
              item.id,
              citem.pid
            )
          }
        }
      }, [_vm._v("\n                    " + _vm._s(citem.name) + "\n                  ")])
    }), 0)])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shenbaoleft"
  }, [_c('ul', _vm._l((_vm.tablist), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search cpoint",
      class: item.checked ? 'active1' : '',
      on: {
        "click": function($event) {
          return _vm.tochange(index, item.type)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "shenbaoright"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "550px"
    }
  }, [_vm._l((_vm.rightlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1"
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [(item.type == 0) ? _c('span', [_vm._v("国家级")]) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('span', [_vm._v("省级")]) : _vm._e(), _vm._v(" "), (item.type >= 2) ? _c('span', [_vm._v("市级")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.city_name ? item.city_name + (item.area_name ? item.area_name : '') : '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.use_start_time ? item.use_start_time : '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.use_end_time ? item.use_end_time : '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.day >= 0 ? '剩余' + item.day + '天' : '已截止'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text3 text-cut cpoint",
      on: {
        "click": function($event) {
          return _vm.todetail('detail', item.id, 1)
        }
      }
    }, [_c('div', {
      staticClass: "box2_nei"
    }, [_vm._v("查看详情")])])])
  }), _vm._v(" "), (_vm.rightlist.length == 0) ? [_c('Nomore')] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "text-center pagecss",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1 text-cut"
  }, [_vm._v("政策名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布等级")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布区域")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("截止日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("剩余天数")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text3 text-cut"
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77aa3642"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bulletin/consulting.vue
// module id = 902
// module chunks = 1